import Component from '@glimmer/component';
import { WithBoundArgs } from '@glint/template';
// @ts-expect-error: There are not type definitions for headlessui switch component
import EmberHeadlessSwitch from 'ember-headlessui/components/switch.js';
import UiSwitchButtonComponent from './switch/button';
import UiSwitchLabelComponent from './switch/label';

interface UiSwitchSignature {
  Element: HTMLDivElement;
  Args: {
    Named: {
      isOn: boolean;
      onUpdate: (value: boolean) => void;
    };
  };
  Blocks: {
    default: [
      {
        isOn: boolean;
        Label: WithBoundArgs<typeof UiSwitchLabelComponent, 'guid' | 'onClick'>;
        Button: WithBoundArgs<
          typeof UiSwitchButtonComponent,
          'guid' | 'labelGuid' | 'isOn' | 'onClick' | 'onKeyUp'
        >;
      }
    ];
  };
}

class UiSwitchComponent extends EmberHeadlessSwitch {}

export default UiSwitchComponent as unknown as typeof Component<UiSwitchSignature>;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Switch': typeof Component<UiSwitchSignature>;
    'ui/switch': typeof Component<UiSwitchSignature>;
  }
}
